/** Default minimum scoped reviews before a widget can show analysis (matches API GenAI default). */
export const WELCOME_WIDGET_DEFAULT_MIN_REVIEW_COUNT = 3;

/**
 * Per-metric minimum review thresholds.
 * Extend when specific metrics need different cutoffs.
 */
export const WELCOME_WIDGET_MIN_REVIEW_COUNT_BY_METRIC = {};

export function resolveWelcomeWidgetMinReviewCount(metricId) {
  const mid = Number(metricId);
  if (
    Number.isFinite(mid) &&
    WELCOME_WIDGET_MIN_REVIEW_COUNT_BY_METRIC[mid] != null
  ) {
    return WELCOME_WIDGET_MIN_REVIEW_COUNT_BY_METRIC[mid];
  }
  return WELCOME_WIDGET_DEFAULT_MIN_REVIEW_COUNT;
}
